import { AppDispatch } from 'src/store';
import { setSnackbarMessage } from 'src/store/snackbarMessage';

export const updateUserAccessMessage = ({ status, dispatch }: { status: number; dispatch: AppDispatch }) => {
  if (status === 401) {
    dispatch(setSnackbarMessage(`Error ${status} Unauthorized access`, 'error'));
  } else if (status === 403) {
    dispatch(setSnackbarMessage(`Error ${status} Restricted User permission`, 'error'));
  } else if (status === 500) {
    dispatch(setSnackbarMessage(`Error ${status} Internal server error.`, 'error'));
  } else if (status === 501) {
    dispatch(setSnackbarMessage(`Error ${status} The request method is not supported by the server.`, 'error'));
  } else if (status === 502) {
    dispatch(setSnackbarMessage(`Error ${status} Bad gateway.`, 'error'));
  } else if (status === 503) {
    dispatch(setSnackbarMessage(`Error ${status} The server is not ready to handle the request.`, 'error'));
  } else if (status === 504) {
    dispatch(setSnackbarMessage(`Error ${status} Gateway timed out.`, 'error'));
  }
};
